import { render, staticRenderFns } from "./currencyWallet.vue?vue&type=template&id=15d8e32e&scoped=true"
import script from "./currencyWallet.vue?vue&type=script&lang=ts"
export * from "./currencyWallet.vue?vue&type=script&lang=ts"
import style0 from "./styles/finrez.scss?vue&type=style&index=0&id=15d8e32e&prod&lang=scss&scoped=true&external"
import style1 from "@/styles/components/progress-bar/progress-bar.scss?vue&type=style&index=1&id=15d8e32e&prod&lang=scss&scoped=true&external"
import style2 from "./currencyWallet.vue?vue&type=style&index=2&id=15d8e32e&prod&lang=scss"
import style3 from "./currencyWallet.vue?vue&type=style&index=3&id=15d8e32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8e32e",
  null
  
)

export default component.exports